export default __webpack_public_path__ + "static/media/icon-user.f6a4d9f2.svg";